import { z } from 'zod';
import { agencySchema } from '../agency/list';
import { userSchema } from '../user/list';

export const meSchema = z.object({
  user: userSchema,
  agency: agencySchema.nullable().optional(),
  subscribedClientIds: z.array(z.string()).optional(),
  favoriteClientIds: z.array(z.string()).optional(),
  isImpersonating: z.boolean().optional(),
});

export type MeSchema = z.infer<typeof meSchema>;
